module.exports = angular.module("ui.router");


//////////////////
// WEBPACK FOOTER
// external "angular.module(\"ui.router\")"
// module id = 423
// module chunks = 0